import React from 'react';
import '../css/IsoHero.css';

const IsoHero = () => {
  return (
    <header className="gfi-iso-hero-banner">
      
      {/* Dark Industrial Gradient Mask Wrapper matching image 15_2 */}
      <div className="gfi-iso-hero-tint-mask"></div>

      <div className="gfi-iso-hero-viewport-mesh">
        <div className="gfi-iso-hero-content-alignment">
          
          {/* TRACK HIERARCHY BREADCRUMB */}
          <nav className="gfi-iso-breadcrumb-row">
            <span className="gfi-iso-bc-item">GROWTH ACADEMY</span>
            <span className="gfi-iso-bc-arrow">&gt;</span>
            <span className="gfi-iso-bc-item">ABOUT</span>
            <span className="gfi-iso-bc-arrow">&gt;</span>
            <span className="gfi-iso-bc-active">ISO</span>
          </nav>

          {/* MASTER BOLD TITLE HEADER */}
          <h1 className="gfi-iso-hero-title-text">
            ISO CERTIFICATION
          </h1>

        </div>
      </div>

    </header>
  );
};

export default IsoHero;